"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DialogTransition: true
};
exports.default = exports.DialogTransition = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Transition = _interopRequireDefault(require("react-transition-group/Transition"));
var _DialogTransition = require("./_DialogTransition.types");
Object.keys(_DialogTransition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DialogTransition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DialogTransition[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// import classnamesBind from 'classnames/bind';

const DialogTransition = props => {
  const {
      children,
      className,
      timeout,
      transitionStyles,
      unmountOnExit = true
    } = props,
    otherProps = __rest(props, ["children", "className", "timeout", "transitionStyles", "unmountOnExit"]);
  return /*#__PURE__*/_react.default.createElement(_Transition.default, Object.assign({}, otherProps, {
    timeout: timeout,
    unmountOnExit: unmountOnExit
  }), (state, innerProps) => /*#__PURE__*/_react.default.cloneElement(children, Object.assign(Object.assign({}, innerProps), {
    className: (0, _classnames.default)(children.props.className, className, transitionStyles === null || transitionStyles === void 0 ? void 0 : transitionStyles[state])
  })));
};
exports.DialogTransition = DialogTransition;
DialogTransition.displayName = 'DialogTransition';
var _default = exports.default = DialogTransition;